import React from "react";
import "./Goal.css";
function Goal() {
  const GoalContent = [
    {
      id: 0,
      title: "Our Mission",
      content: (
        <p
          style={{
            fontSize: "20px",
            paddingLeft: "70px",
            display: "flex",
            fontFamily: "revert",
          }}
        >
          "Women Wings builds the capabilities of grassroots organisations and
          the women they work with. By investing in organisation building,
          injecting business acumen, upgrading quality and production
          infrastructure and providing market linkages, we generate livelihoods,
          create women entrepreneurs and build enterprises.",
        </p>
      ),
    },
    {
      id: 1,
      title: "Our Vision",
      content: (
        <p
          style={{
            paddingLeft: "70px",
            fontSize: "20px",
            fontFamily: "revert",
          }}
        >
          " Women in India prosper through meaningful work that allows them to
          balance their domestic responsibilities, with opportunities for social
          and economic empowerment.",
        </p>
      ),
    },
    {
      id: 2,
      title: "Our Values",
      content: (
        <ul
          style={{
            fontSize: "20px",
            paddingLeft: "60px",
            fontWeight: "20px",
            // color: "white",
            // fontFamily: "cursive",
          }}
        >
          <li> Be Transparent </li>
          <li> Be Impact First </li>
          <li style={{ paddingRight: "16px" }}> Be Effectable</li>
          <li style={{ paddingLeft: "10px" }}> Be Accountable</li>
          <li> Be Resourceful </li>
          <li> Be Professional </li>
        </ul>
      ),
    },
  ];
  return (
    <div
      className="goal_main_container"
      style={{
        display: "flex",
        flex: 1,
        // marginTop: "30px",/
        height: "85vh",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "80px",
      }}
    >
      <div className="goal_overlay"></div>
      <div
        style={{
          flex: 1,
          display: "flex",
          color: "#fff",
          // width: "100px",
          zIndex: 2,
        }}
      >
        {GoalContent?.map((item, _) => {
          return (
            <div
              style={{ display: "flex", flexDirection: "column", flex: 1 }}
              key={item?.id}
            >
              <h2
                style={{
                  fontSize: "40px",
                  fontFamily: "sans-serif",
                  paddingLeft: "50px",
                }}
              >
                {item?.title}
              </h2>
              <div>
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0px 24px",
                    fontFamily: "sans-serif",
                    fontSize: "16px",
                  }}
                >
                  {item?.content}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Goal;
